import styled from 'styled-components'
import { institutionalColors } from '~/design'

type AlertType = 'info' | 'warn' | 'success' | 'error'

interface AlertMessageProps {
  type: AlertType
  title: string
  description?: string
  style?: React.CSSProperties
}

const alertStyles = {
  error: {
    color: '#b22400',
    backgroundColor: '#ffe5e5',
    borderColor: '#b22400',
  },
  warn: {
    color: '#AB6005 ',
    backgroundColor: '#FFFAE6',
    borderColor: '#FFB31A',
  },
  success: {
    color: '#00662A',
    backgroundColor: '#EBFAF0',
    borderColor: '#35B068',
  },
  info: {
    color: '#005EB8',
    backgroundColor: '#F0F6FE',
    borderColor: '#5C8FD6',
  },
}

const AlertContainer = styled.div<{ $type: AlertType }>`
  color: ${props => alertStyles[props.$type].color};
  background-color: ${props => alertStyles[props.$type].backgroundColor};
  padding: 10px;
  border-radius: 4px;
  border: 1px solid ${props => alertStyles[props.$type].borderColor};
`

const AlertTitle = styled.h4<{ $type: AlertType; $description?: string }>`
  margin: 0 0 ${props => (props.$description ? '4px' : '0')} 0;
  color: ${props => alertStyles[props.$type].color};
  font-size: 16px;
  font-weight: 700;
`

const AlertDescription = styled.p`
  margin: 0;
  color: ${institutionalColors.graySebrae30};
  font-size: 13px;
`

export default function AlertMessage({ type, title, description, style }: AlertMessageProps) {
  return (
    <AlertContainer $type={type} style={style}>
      <AlertTitle $type={type} $description={description}>
        {title}
      </AlertTitle>
      {description && <AlertDescription>{description}</AlertDescription>}
    </AlertContainer>
  )
}
